import styles from './service.module.css'
export default function C1pt(){
    return(
        <div style={{width: "80%", margin: "auto", paddingTop: '40px'}}>
                <div className={styles.cardContainer2}>
          <div className={styles.cardContainer3}>
            <div className={styles.cardTitle}>
              1C:Müəssisə proqram təminatının hazırlanması
            </div>
            <div className={styles.cartDesc}>
              • Layihə qabağı müayinənin keçirilməsi <br />
              • Texniki tapşırığın tərtib edilməsi <br />
              • Proqram təminatının digər sistemlər ilə inteqrasiya edilməsi{" "}
              <br />• 1C sisteminin optimallaşdırılması və məhsuldarlığının
              artırılması
            </div>
          </div>

          <div className={styles.cardContainer3}>
            <div className={styles.cardTitle}>
            1C:Müəssisə proqram təminatının serverdə quraşdırılması
            </div>
            <div className={styles.cartDesc}>
            •	Məlumat bazasının quraşdırılması və sazlanması <br />
•	Proqram təminatının quraşdırılması və sazlanması <br />
•	Paylanmış bazaların idarəetmə sisteminin quraşdırılması və sazlanması

            </div>
          </div>

          <div className={styles.cardContainer3}>
            <div className={styles.cardTitle}>
            1C:Müəssisə proqram təminatının iş yerlərində tətbiq edilməsi
            </div>
            <div className={styles.cartDesc}>
            •	Proqram təminatının quraşdırılması və sazlanması <br />
•	Proqram təminatının iş prinsiplərinin öyrədilməsi, qısa təlim kursu <br />
•	Proqram təminatının iş prinsiplərinin öyrədilməsi, tam təlim kursu <br />
•	Proqram təminatının iş prinsiplərinin öyrədilməsi, saatlıq təlim kursu <br />
•	Proqram təminatının tətbiq edilməsi

            </div>
          </div>

          <div className={styles.cardContainer3}>
            <div className={styles.cardTitle}>
            1C:Müəssisə proqram təminatının xidməti
            </div>
            <div className={styles.cartDesc}>
            •	1C:Mütəxəssis-məsləhətçinin çağırışı, Bakı ş. daxilində <br />
•	1C:Mütəxəssis-məsləhətçinin xidmətləri, Bakı ş. daxilində <br />
•	1C:Mütəxəssis-məsləhətçinin xidmətləri, Bakı ş. xaricində <br />
•	İş yerlərində proqram təminatının abunə xidməti <br />
•	Serverdə proqram təminatının abunə xidməti

            </div>
          </div>
        </div>
        </div>
    )
}